import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
export function Solucion() {
  const points = [{
    title: 'Fortalecé el músculo de tu válvula esofágica',
    desc: 'A través de presión diafragmática y ajuste químico natural, le enseñás a tu cuerpo a cerrar la tapa herméticamente.'
  }, {
    title: 'Resultados desde las primeras 72 horas',
    desc: 'No vaciamos el tanque de ácido. Enseñamos a cerrar la válvula. Por eso los cambios son rápidos y duraderos.'
  }, {
    title: 'Funciona aunque tengas hernia hiatal o gastritis',
    desc: 'El fortalecimiento muscular es especialmente vital para quienes tienen hernia. El protocolo está diseñado para situaciones reales.'
  }, {
    title: 'Reducí la dependencia del omeprazol gradualmente',
    desc: 'El protocolo funciona como complemento a tu medicación actual. Incluye guía para reducir la dependencia de forma segura.'
  }];
  return <section id="solucion" className="py-[100px] bg-[radial-gradient(ellipse_70%_50%_at_50%_50%,rgba(224,122,80,0.12)_0%,transparent_70%),linear-gradient(180deg,#201408_0%,#120806_100%)]" data-id="element-309">
      <div className="container-sm" data-id="element-310">
        <div className="text-center mb-16" data-id="element-311">
          <p className="text-[11px] tracking-[3px] uppercase text-gold mb-3" data-id="element-312">
            La solución
          </p>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-gold to-gold-light mx-auto mb-4" data-id="element-313" />
          <div className="flex justify-center mb-4" data-id="element-314">
            <span className="inline-flex items-center gap-2 bg-gradient-to-br from-gold/20 to-gold/5 border border-gold/40 text-gold text-[12px] font-semibold tracking-[1px] px-5 py-2 rounded-full" data-id="element-315">
              ✦ Mecanismo Cardias-Lock™
            </span>
          </div>
          <h2 className="font-display text-[clamp(28px,4vw,44px)] font-black leading-[1.2] mb-4 text-white" data-id="element-316">
            No es una dieta.
            <br data-id="element-317" />
            <span className="text-gold" data-id="element-318">Es ingeniería biológica.</span>
          </h2>
          <p className="text-[17px] text-gray leading-[1.7] max-w-[620px] mx-auto" data-id="element-319">
            Vinagre de manzana, bicarbonato, sábila, omeprazol... todo apaga el
            síntoma pero no arregla la causa. El Mecanismo Cardias-Lock™ le
            enseña a tu cuerpo a cerrar la válvula herméticamente. En lugar de
            vaciar el tanque, sellamos la tapa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[60px] items-center" data-id="element-320">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-[12px] overflow-hidden border border-gold/20 shadow-[0_20px_60px_rgba(0,0,0,0.5)] bg-[#201408] aspect-[4/3] relative flex items-center justify-center" data-id="element-321">
            <img src="https://i.postimg.cc/9MBfVQ1x/libro-principal.webp" alt="Reflujo Cero en 72h — Protocolo de Reprogramación Digestiva" className="w-full h-full object-contain p-6 animate-float" loading="lazy" data-id="element-322" />
            <div className="absolute inset-0 bg-gradient-to-br from-gold/10 to-transparent pointer-events-none" data-id="element-323" />
          </motion.div>

          <ul className="list-none flex flex-col" data-id="element-324">
            {points.map((point, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className={`flex gap-3.5 py-4 items-start ${idx !== points.length - 1 ? 'border-b border-gold/10' : ''}`} data-id="element-325">
                <div className="w-6 h-6 rounded-full bg-gradient-to-br from-gold to-gold-light flex items-center justify-center shrink-0 mt-0.5" data-id="element-326">
                  <Check className="w-3 h-3 text-deep stroke-[3]" data-id="element-327" />
                </div>
                <div data-id="element-328">
                  <strong className="block text-white text-[15px] mb-1 font-semibold" data-id="element-329">
                    {point.title}
                  </strong>
                  <span className="text-[13px] text-gray leading-[1.5]" data-id="element-330">
                    {point.desc}
                  </span>
                </div>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}